<template>
<div>
    <Row type="flex" justify="end" style="margin-bottom: 40px;">
        <i-col>
            <i-select filterable v-model="analista" clearable @on-change="filterData" placeholder="Analista" style="width:200px;margin-left:7px;">
                <Option v-for="item in analistas" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </i-select>
            <i-select filterable v-model="tipo" clearable @on-change="filterData" placeholder="Tipo de ticket" style="width:200px;margin-left:7px;">
                <Option v-for="item in tipos" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </i-select>
            <InputNumber :active-change="false" :min="1" v-model="periodo" style="margin-left:7px;"></InputNumber>
            <i-switch @on-change="getStats" false-value="mensal" size="large" style="margin: 7px 0 7px 7px;"
                      true-value="semanal" v-model="formato">
                <span slot="open">SEM</span>
                <span slot="close">MEN</span>
            </i-switch>
        </i-col>
    </Row>
    <bar-chart
        v-if="show_graphs"
        :options="chartData"
        @click="getDetails"
        />
    <Spin size="large" fix v-if="showSpin"></Spin>
    <TicketsTable :csv="csv" :analistas="analistas" :loading="loading" :relatores="analistas"
                  :tickets="tickets" v-if="showTable" exibir-detalhes ></TicketsTable>
    <drawer :closable="true" placement="right" title="Ticket" v-model="edit_pgd" width="850">
        <ticket :id="edit_id" v-if="edit_pgd"></ticket>
    </drawer>
</div>
</template>

<script>
    const {moment, toQueryString} = require("../../../helpers/utils.js");
    export default {
        props: {
            download: Boolean,
            refresh: Boolean,
            close: Boolean
        },
        components: {
            BarChart: () => import("../../../components/charts/BarChart.vue"),
        },
        data() {
            return {
                analista: null,
                tipo: null,
                formato: 'semanal',
                chartData: {},
                show_graphs:true,
                stats_data: [],
                periodo: 6,
                legenda: [],
                showSpin: false,
                showTable: false,
                loading: false,
                edit_pgd: false,
                edit_id: 0,
                tipos: [
                    {
                        label: "Bug",
                        value: 32
                    },
                    {
                        label: "Melhoria",
                        value: 33
                    },
                    {
                        label: "SS",
                        value: 35
                    },
                    {
                        label: "MVP",
                        value: 45
                    }
                ],
                totais:[],
                csv:false,
            }
        },
        computed: {
            analistas() {
                let analistas = this.$store.getters['analistas']
                    .map(item => ({
                        value: item.id_pessoa,
                        label: item.nome
                    }));
                return _.orderBy(analistas, ['label'],['asc'])
            },
        },
        methods: {
            async getStats() {
                this.showSpin = true;
                this.showTable = false;

                const URI = `ticket/estatisticas/tempo?formato=${this.formato}&periodo=${this.periodo}`;
                const {data} = await this.$axios.get(URI);
                this.showSpin = false;

                this.stats_data = data.reverse();
                
                this.legenda = this.getLegenda(data.length);
                this.filterData();
            },
            filterData() {
                this.showTable = false;
                let stats = this.stats_data;
                this.getTotais([
                    stats.map((tl) => this.filtroTotais(tl.atribuido)), // Bugs aprovados
                    stats.map((tl) => this.filtroTotais(tl.desenvolvimento)), // Mel aprovados
                    stats.map((tl) => this.filtroTotais(tl.analise)), // SS aprovados
                    stats.map((tl) => this.filtroTotais(tl.aguardando)), // MVP aprovados
                    stats.map((tl) => this.filtroTotais(tl.master)), 
                ]);
                this.fillData([
                    stats.map((tl) => this.calcAvg(tl.atribuido)), // Bugs aprovados
                    stats.map((tl) => this.calcAvg(tl.desenvolvimento)), // Mel aprovados
                    stats.map((tl) => this.calcAvg(tl.analise)), // SS aprovados
                    stats.map((tl) => this.calcAvg(tl.aguardando)), // MVP aprovados
                    stats.map((tl) => this.calcAvg(tl.master)), // MVP aprovados
                ]);
            },
            getTotais([
                atribuido,
                desenvolvimento,
                analise,
                teste,
                aguardando,
                master
            ]){
                this.totais.push(atribuido,desenvolvimento,analise,teste,aguardando,master)
            },
            filtroTotais(dados){
                const analista = this.analista;
                const tipo = this.tipo;
                this.totais=[];
                dados = dados.filter(item => {
                        if (analista && tipo) {
                            return analista == item.atribuido_a_id && tipo == item.tipo_id;
                        }
                        if (analista) {
                            return analista == item.atribuido_a_id;
                        }
                        if (tipo) {
                            return tipo == item.tipo_id;
                        }
                        return item;
                    })
                return dados.length
            },
            /**
             * Calcula a média de tempo que os tickets ficaram em determinado periodo
             *
             * @param stage
             * @returns {number}
             */
            calcAvg(stage) {
                const analista = this.analista;
                const tipo = this.tipo;
                return Math.round(stage
                    .filter(item => {
                        if (analista && tipo) {
                            return analista == item.atribuido_a_id && tipo == item.tipo_id;
                        }
                        if (analista) {
                            return analista == item.atribuido_a_id;
                        }
                        if (tipo) {
                            return tipo == item.tipo_id;
                        }
                        return item;
                    })
                    .map(item => moment(item.registro_posterior).diff(item.data_hora_registro, 'seconds') || 0)
                    .reduce((accum, curr) => accum + curr, 0) / stage.length / 60);
            },
            isNan(item){
                if(isNaN(item)){
                    return 0
                }
                return item
            },
            fillData([
                atribuido,
                desenvolvimento,
                analise,
                teste,
                aguardando,
                master
            ]) {
                let totais_hs = []
                for (let index = 0; index < this.periodo; index++) {
                    totais_hs.push(this.isNan(atribuido[index])+this.isNan(desenvolvimento[index])+this.isNan(analise[index])+this.isNan(teste[index])+this.isNan(aguardando[index])+this.isNan(master[index]))                    
                }
                
                const labelTop = {
                    normal: {
                        position: 'top',
                        show: true,
                        formatter: (param) => param.value ? `${Math.round(param.value/60)} hs` : '',
                    }
                };

                this.chartData = {
                    legend: {},
                    tooltip: {
                        type:'shadow',
                        formatter:(params)=>{
                            if(params.seriesIndex!=6){
                                return `
                                    <span>${params.seriesName}</span><br>
                                    <span>${params.marker} ${params.name}: ${params.data.value} min</span><br>
                                    <span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#263238;"></span><span> Total: ${this.totais[params.seriesIndex][params.dataIndex]}</span>
                                `  
                            }
                            let soma = 0
                            for (let index = 0; index < 6; index++) {
                                soma+= this.totais[index][params.dataIndex]
                            }
                            return `
                                <span>${params.seriesName}</span><br>
                                <span>${params.marker} Tickets: ${soma}</span><br>
                                <span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#018ED4;"></span><span> Tempo: ${params.data.value} min</span>
                            `
                        }
                    },
                    xAxis: {
                        data: this.legenda,
                        silent: false,
                        axisLine: {onZero: true},
                        splitArea: {show: false},
                        splitLine: {show: false}
                    },
                    yAxis: {},
                    grid: {
                        left: 50,
                        right: 50
                    },
                    series: [
                        {
                            name: 'Atribuído',
                            type: 'bar',
                            itemStyle: {
                                normal: {
                                    barBorderWidth: 2,
                                    barBorderColor: "#ff1744"
                                },
                                emphasis: {
                                    barBorderWidth: 2,
                                    barBorderColor: "#ff1744"
                                }
                            },
                            color: '#ff1744',
                            data: atribuido.map((value) => ({
                                value: value || '',
                                itemStyle: {
                                    barBorderColor: '#ff1744',
                                }
                            })),
                            label: labelTop,
                        },
                        {
                            name: 'Em desenvolvimento',
                            type: 'bar',
                            itemStyle: {
                                normal: {
                                    barBorderWidth: 2,
                                    barBorderColor: "#e91e63"
                                },
                                emphasis: {
                                    barBorderWidth: 2,
                                    barBorderColor: "#e91e63"
                                }
                            },
                            color: '#e91e63',
                            data: desenvolvimento.map((value) => ({
                                value: value || '',
                                itemStyle: {
                                    barBorderColor: '#e91e63',
                                }
                            })),
                            label: labelTop,
                        },
                        {
                            name: 'Análise de qualidade',
                            type: 'bar',
                            itemStyle: {
                                normal: {
                                    barBorderWidth: 2,
                                    barBorderColor: "#ff9800"
                                },
                                emphasis: {
                                    barBorderWidth: 2,
                                    barBorderColor: "#ff9800"
                                }
                            },
                            color: '#ff9800',
                            data: analise.map((value) => ({
                                value: value || '',
                                itemStyle: {
                                    barBorderColor: '#ff9800',
                                }
                            })),
                            label: labelTop,
                        },
                        {
                            name: 'Em teste',
                            type: 'bar',
                            itemStyle: {
                                normal: {
                                    barBorderWidth: 2,
                                    barBorderColor: "#ffeb3b"
                                },
                                emphasis: {
                                    barBorderWidth: 2,
                                    barBorderColor: "#ffeb3b"
                                }
                            },
                            color: '#ffeb3b',
                            data: teste.map((value) => ({
                                value: value || '',
                                itemStyle: {
                                    barBorderColor: '#ffeb3b',
                                }
                            })),
                            label: labelTop,
                        },
                        {
                            name: 'Aguardando Merge',
                            type: 'bar',
                            itemStyle: {
                                normal: {
                                    barBorderWidth: 2,
                                    barBorderColor: "#4caf50"
                                },
                                emphasis: {
                                    barBorderWidth: 2,
                                    barBorderColor: "#4caf50"
                                }
                            },
                            color: '#4caf50',
                            data: aguardando.map((value) => ({
                                value: value || '',
                                itemStyle: {
                                    barBorderColor: '#4caf50',
                                }
                            })),
                            label: labelTop,
                        },
                        {
                            name: 'Merge Master',
                            type: 'bar',
                            itemStyle: {
                                normal: {
                                    barBorderWidth: 2,
                                    barBorderColor: "#009688"
                                },
                                emphasis: {
                                    barBorderWidth: 2,
                                    barBorderColor: "#009688"
                                }
                            },
                            color: '#009688',
                            data: master.map((value) => ({
                                value: value || '',
                                itemStyle: {
                                    barBorderColor: '#009688',
                                }
                            })),
                            label: labelTop,
                        },
                        {
                            name: 'Totais',
                            type: 'line',
                            color: '#263238',
                            data: totais_hs,
                            label: labelTop,
                        },
                    ]
                };
            },
            getLegenda(size) {
                let legenda = [];
                if (this.formato === "semanal") {
                    legenda = ["Esta sem.", "1 sem. atrás"];
                    for (let i = 2; i < size; i++) {
                        legenda[i] = `${i} sem. atrás`;
                    }
                } else {
                    for (let i = 0; i < size; i++) {
                        legenda[i] = moment().subtract(i, 'months').format("MMMM/YY");
                    }
                }
                return legenda.reverse();
            },
            getDetails(params) {
                if (!params.selected) {
                    const analista = this.analista
                    const tipo = this.tipo
                    const dataIndex = params.dataIndex
                    let ids = null
                    if(params.seriesType === "line"){
                        const dados = this.stats_data.map(function(item){
                            const aguardando = item.aguardando
                            const analise = item.analise
                            const atribuido = item.atribuido
                            const desenvolvimento = item.desenvolvimento
                            const master = item.master
                            const teste = item.teste
                            return aguardando.concat(analise,atribuido,desenvolvimento,master,teste).filter(item => {
                                if (analista && tipo) {
                                    return analista == item.atribuido_a_id && tipo == item.tipo_id;
                                }
                                if (analista) {
                                    return analista == item.atribuido_a_id;
                                }
                                if (tipo) {
                                    return tipo == item.tipo_id;
                                }
                                return item;
                            }).map(item => item.id_ticket)
                        })
                        ids = dados[dataIndex]
                    } else {
                        const seriesIndex = params.seriesIndex
                        const types = ['atribuido','desenvolvimento', 'analise', 'teste', 'aguardando', 'master'];
                        const type = types[seriesIndex];
                        ids = this.stats_data[dataIndex][type]
                            .filter(item => {
                                if (analista && tipo) {
                                    return analista == item.atribuido_a_id && tipo == item.tipo_id;
                                }
                                if (analista) {
                                    return analista == item.atribuido_a_id;
                                }
                                if (tipo) {
                                    return tipo == item.tipo_id;
                                }
                                return item;
                            }).map(item => item.id_ticket)
                    }
                    const URI = `ticket/estatisticas/qualidade/detalhe?${toQueryString({
                            ids,
                    })}`
                    this.loading = true;
                    this.$axios.get(URI).then(({data}) => {
                        this.tickets = data.data.map(item => {
                            item.solicitantes = item.solicitantes
                                ? JSON.parse(item.solicitantes)
                                : [];
                            return item
                        });
                        this.showTable = true;
                        this.loading = false;
                    }).catch(err => {
                        console.warn(err);
                        this.showTable = false;
                    })
                } else {
                    this.showTable = false;
                }
            },
            async getUsuarios() {
                if (this.$store.getters['usuarios'].length === 0) {
                    const {data} = await this.$axios.get(`pessoa`);
                    this.$store.dispatch('loadUsers', data);
                }
            },
        },
        created() {
            this.getUsuarios();
            this.getStats();
        },
        watch: {
            refresh(){
                if (this.refresh){
                    this.analista = null
                    this.tipo = null
                    this.formato = 'semanal'
                    this.periodo = 6
                    this.showTable = false
                    this.getUsuarios()
                    this.getStats()
                }
            },
            download(){
                this.csv=this.download
            },
            close(){
                if (this.close){
                    this.showTable = false
                    this.show_graphs = false
                } else {
                    this.show_graphs = true
                }    
            },
            analista(){
                this.filterData()
                this.showTable = false
            },
            tipo(){
                this.filterData()
                this.showTable = false
            },
            periodo(){
                this.getStats()
                this.showTable = false
            },
            formato(){
                this.getStats()
                this.showTable = false
            },
            showTable(){
                this.$emit('download',this.showTable)
            }
        }
    }
</script>

<style scoped>
    .spin-container {
        position: relative;
    }
</style>
